import { useMemo } from "react";
import { GuestUser } from "@scrile/api-provider/dist/api/GuestUsersProvider";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import useBreakPoints from "hooks/useBreakPoints";
import { getAttachmentViews } from "lib/attachmentViews";

export default function useViewController(
  message: Message,
  authUser: User | null,
  isLiveChat?: boolean,
  guestUser?: GuestUser | null
) {
  const { desktopUp } = useBreakPoints();

  const selfMessage = guestUser ? message.link?.subject.subjectId === guestUser.id : message.senderId === authUser?.id;
  let highlightMessage: boolean;
  if (isLiveChat) {
    highlightMessage = !!message.senderUser?.publicLivechatUser?.broadcasting;
  } else {
    highlightMessage = !selfMessage;
  }

  const attachmentViews = useMemo(() => getAttachmentViews(message), [message]);

  return {
    desktopUp,
    highlightMessage,
    selfMessage,
    attachmentViews,
  };
}
